import React, { useEffect } from 'react';
import { Spin } from 'antd';

const LogoutPage = (props) => {
	useEffect(() => {
		props.logout();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return(
		<div style={{ display: 'flex', height: '100vh', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
			<Spin/>
		</div>
	);
};

export default LogoutPage;
